<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
    @click="handleClick"
  >
    <div
      class="tw-flex tw-items-center"
      style="width: 17.16%"
    >
      <i-user-avatar
        :avatar="foreigner.avatar_url && foreigner.avatar_url['128'] && `${$baseHost}/${foreigner.avatar_url['128']}`"
        :fullname="foreigner.fullname"
        :status="foreigner.status"
        size="small"
        class="tw-mr-3"
      />
      <div>
        <strong class="tw-block tw-leading-5 tw-mb-0.5 tw-font-medium">
          {{ foreigner.fullname }}
        </strong>
        <div class="tw-text-xs tw-leading-[14px] tw-text-gray-dark">
          {{ $capitalize(foreigner.relationship_type_name?? '') }}
        </div>
        <div
          v-if="foreigner.family_profiles"
          class="tw-text-xs tw-leading-[14px] tw-text-gray-dark"
        >
          <div
            v-if="foreigner.master"
            class="tw-flex tw-items-center tw-text-xs tw-leading-[14px]"
            :class="foreigner.family_profiles.length ? 'tw-text-primary tw-cursor-pointer' : 'tw-text-gray-dark'"
            @click.stop="foreigner.family_profiles.length > 0 ? $emit('toggleExpanded') : null"
          >
            {{ $capitalize('main') }}
            <div class="tw-flex tw-items-center">
              <span v-if="foreigner.family_profiles.length > 0">&nbsp;+{{ foreigner.family_profiles.length }}
              </span>
              <div
                v-if="foreigner.family_profiles.length > 0"
                class="tw-ml-1 tw-transition-transform tw-duration-200"
                :class="{ 'tw-rotate-180' : expanded }"
              >
                <icon-foreigner-accordeon />
              </div>
            </div>
          </div>
          <div v-else>
            {{ $capitalize(relationType?? '') }}
          </div>
        </div>
      </div>
    </div>

    <div style="width: 6%">
      {{ foreigner.citizenship }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      style="width: 18.06%"
    >
      <template v-if="foreigner.main_permit_type === 30">
        {{ $t('foreigners.filters.obtained') }}
      </template>
      <template v-else>
        <span
          class="tw-text-gray-dark dark:tw-text-dm-gray-dark"
        >
          {{ foreigner.main_permit_status_index }}
        </span>
        {{ foreigner.main_permit_status }}
      </template>
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      style="width: 7.24%"
    >
      {{ foreigner.main_permit_expiration_date }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      style="width: 7.24%"
    >
      {{ foreigner.main_permit_renewal_date }}
    </div>

    <div style="width: 3.62%">
      <div class="tw-flex tw-justify-start">
        <i-badge :type="foreigner.survey_submitted ? 'success' : 'default'">
          {{ foreigner.survey_submitted ? 'Yes' : 'No' }}
        </i-badge>
      </div>
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      style="width: 5.07%"
    >
      {{ foreigner.client_company_name }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      style="width: 10.98%"
    >
      {{ foreigner.date_modified }}
    </div>

    <div style="width: 9%">
      <div
        class="tw-flex tw-items-center"
      >
        <div
          class="tw-flex tw-items-center"
        >
          <el-tooltip
            :content="foreigner.assigned_to_fullname"
          >
            <i-user-avatar
              :avatar="foreigner.assigned_to_avatar_url && foreigner.assigned_to_avatar_url['128'] && `${$baseHost}/${foreigner.assigned_to_avatar_url['128']}`"
              :fullname="foreigner.assigned_to_fullname"
              size="small"
            />
          </el-tooltip>
        </div>
        <a
          :href="`/foreigners/${foreigner.id}`"
          target="_blank"
          class="tw-block tw-ml-5"
        >
          <i-button
            type="white"
            is-icon
          >
            <icon-open-external />
          </i-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    foreigner: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    relationType() {
      const relationType = this.$store.getters['v2/shared/enums/get']('family_relations', this.foreigner.relation_type);
      return relationType ? relationType.name : '';
    },
  },

  methods: {
    handleClick(event) {
      if (!event.target.closest('a')) {
        this.$router.push(`/foreigners/${this.foreigner.id}`);
      }
    },
  },
};
</script>
